<template>
  <div class="outBox">
    <div class="bannerBox">
      <mobileHeader></mobileHeader>
      <div class="swiper-container3">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in slideshowList" :key="index">
            <img :src="item.image" alt="" />
            <div class="titBox">
              <img class="imgBox" :class="{imgBox1: flag === true}" src="../../../static/images/bg01.png" alt="" />
              <div class="txtBox" :class="{txtBox1: flag === true}">
                <p class="txt1">{{ item.title }}</p>
                <p class="txt2">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="titleBox">
        <ul>
          <li @click="toPage(0)">
            <img class="banBox" src="../../../static/images/icon00.png" alt="" />{{ menuList[0].menuName }}
          </li>
          <li @click="toPage(1)">
            <img class="banBox" src="../../../static/images/icon00.png" alt="" />{{ menuList[1].menuName }}
          </li>
          <li @click="addLogo" v-if="infoObj.websiteLogo">
            <img class="banBox" src="../../../static/images/icon00.png" alt="" />
            <img class="logoBox" :src="infoObj.websiteLogo" alt="" />
          </li>
          <li @click="toPage(2)">
            <img class="banBox" src="../../../static/images/icon00.png" alt="" />{{ menuList[2].menuName }}
          </li>
          <li @click="toPage(3)">
            <img class="banBox" src="../../../static/images/icon00.png" alt="" />{{ menuList[3].menuName }}
          </li>
        </ul>
      </div>
    </div>
    <div class="cententBox">
      <div class="jianjie">
        <div class="left-box">
          <img class="img" style="width: 43px; height: 49px" src="../../../static/images/icon.png" alt="" />
          <div class="txt-box" :class="{'txt-box1': jjflag === true}">
            <p class="t1">{{ homeList[2].moduleName }}</p>
            <p class="t3">{{ homeList[2].moduleEnglishName }}</p>
          </div>
        </div>
        <div class="lunboSwiper">
          <div class="swiper-container1">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img :src="articleList1[0].articleImg" alt="" />
              </div>
              <div class="swiper-slide">
                <img :src="articleList1[1].articleImg" alt="" />
              </div>
              <div class="swiper-slide">
                <img :src="articleList1[2].articleImg" alt="" />
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
        <div class="img-box" :class="{'img-box1': flag === true}">
          <img :src="articleList1[0].articleImg" alt="" />
          <img :src="articleList1[1].articleImg" alt="" />
          <img :src="articleList1[2].articleImg" alt="" />
        </div>
      </div>
      <div class="lunboBox1">
        <div class="swiper-container2">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="ctnBox">
                <img :src="articleList3.list[0].articleImg" alt="" />
                <div class="posBox" :class="{txtflex: swiperNum3 === 0}">
                  <p class="p1">{{ articleList3.list[0].articleTitle }}</p>
                  <p class="p2">{{ articleList3.list[0].createTime }}</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="ctnBox">
                <img :src="articleList4.list[0].articleImg" alt="" />
                <div class="posBox" :class="{txtflex: swiperNum3 === 1}">
                  <p class="p1">{{ articleList4.list[0].articleTitle }}</p>
                  <p class="p2">{{ articleList4.list[0].createTime }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
      <!-- 更换图片 -->
      <!-- <div class="productBox">
        <div class="ctnBox" :class="{ctnBox1: productFlag === true}">
          <div class="flBox fl1" @click="toProduct(0)">
            <img class="img1" src="../../../static/images/img04.png" style="width: 189px; height: 254px" alt="" />
            <img class="img2" src="../../../static/images/img04-1.png" style="width: 189px; height: 254px" alt="" />
          </div>
          <div class="flBox fl2" @click="toProduct(1)">
            <img class="img1" src="../../../static/images/img05.png" style="width: 189px; height: 254px" alt="" />
            <img class="img2" src="../../../static/images/img05-1.png" style="width: 189px; height: 254px" alt="" />
          </div>
          <div class="flBox fl3" @click="toProduct(2)">
            <img class="img1" src="../../../static/images/img06.png" style="width: 189px; height: 254px" alt="" />
            <img class="img2" src="../../../static/images/img06-1.png" style="width: 189px; height: 254px" alt="" />
          </div>
          <div class="flBox fl4" @click="toProduct(3)">
            <img class="img1" src="../../../static/images/img07.png" style="width: 189px; height: 254px" alt="" />
            <img class="img2" src="../../../static/images/img07-1.png" style="width: 189px; height: 254px" alt="" />
          </div>
          <div class="flBox fl5" @click="toProduct(4)">
            <img class="img1" src="../../../static/images/img08.png" style="width: 189px; height: 254px" alt="" />
            <img class="img2" src="../../../static/images/img08-1.png" style="width: 189px; height: 254px" alt="" />
          </div>
          <div class="flBox fl6" @click="toProduct(5)">
            <img class="img1" src="../../../static/images/img09.png" style="width: 189px; height: 254px" alt="" />
            <img class="img2" src="../../../static/images/img09-1.png" style="width: 189px; height: 254px" alt="" />
          </div>
        </div>
      </div> -->
      <!-- 图文 -->
      <div class="productBox">
        <div class="ctnBox" :class="{ctnBox1: productFlag === true}">
          <div class="flBox" v-for="(item, index) in menuList[0].childrenList" :key="index" @click="toProduct(index)">
            <img class="img1" :src="item.menuIcon" alt="" />
            <p>{{ item.menuName }}</p>
          </div>
        </div>
      </div>
      <div class="jieshao">
        <div class="imgBox1" :class="{'imgBox1-1': imgFlag1 === true}">
          <img class="img1" :src="articleList2[0].articleImg" alt="" />
        </div>
        <div class="rightTxt" :class="{rightTxt1: rightFlag === true}">
          <p style="font-size: 38px">{{ articleList2[0].articleTitle }}</p>
          <p style="font-size: 14px; line-height: 2; color: #888; margin: 22px 0">
            {{ articleList2[0].articleAbstract }}
          </p>
          <p class="btnBox" @click="toProductDetails(articleList2[0].id, 0, true)">查看详情 ></p>
          <img class="img-box" src="../../../static/images/icon02.png" alt="" />
        </div>
        <div class="imgBox2" :class="{'imgBox2-1': imgFlag2 === true}">
          <img class="img1" :src="articleList2[1].articleImg" alt="" />
        </div>
        <div class="leftTxt" :class="{leftTxt1: leftFlag === true}">
          <p style="font-size: 38px">{{ articleList2[1].articleTitle }}</p>
          <p style="font-size: 14px; line-height: 2; color: #888; margin: 22px 0">
            {{ articleList2[1].articleAbstract }}
          </p>
          <p class="btnBox" @click="toProductDetails(articleList2[1].id, 1, true)">查看详情 ></p>
          <img class="img-box" src="../../../static/images/icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="banhuaBox">
      <img class="imgbj" :src="advertisingObj1.image" alt="" />
      <div class="ctnBox" :class="{ctnBox1: ctnBoxFlag === true}">
        <img src="../../../static/images/icon02.png" style="width: 30px; height: 36px" alt="" />
        <p>{{ advertisingObj1.desc }}</p>
      </div>
    </div>
    <div class="lunboBox">
      <div class="leftSwiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="ctnBox">
                <img :src="articleList3.list[0].articleImg" alt="" />
                <div class="posBox" :class="{txtflex: swiperNum1 === 0}">
                  <p class="p1">{{ articleList3.list[0].articleTitle }}</p>
                  <p class="p2">{{ articleList3.list[0].articleSubhead }}</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="ctnBox">
                <img :src="articleList3.list[1].articleImg" alt="" />
                <div class="posBox" style="display: block" v-if="swiperNum1 === 1">
                  <p class="p1">{{ articleList3.list[1].articleTitle }}</p>
                  <p class="p2">{{ articleList3.list[1].articleSubhead }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
      <div class="rightSwiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="ctnBox">
                <img :src="articleList4.list[0].articleImg" alt="" />
                <div class="posBox" :class="{txtflex: swiperNum2 === 0}">
                  <p class="p1">{{ articleList4.list[0].articleTitle }}</p>
                  <p class="p2">{{ articleList4.list[0].articleSubhead }}</p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="ctnBox">
                <img :src="articleList4.list[1].articleImg" alt="" />
                <div class="posBox" style="display: block" v-if="swiperNum2 === 1">
                  <p class="p1">{{ articleList4.list[1].articleTitle }}</p>
                  <p class="p2">{{ articleList4.list[1].articleSubhead }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>
    <div class="btmBannerBox">
      <img class="img" :src="advertisingObj2.image" alt="" />
      <div class="cenBox">
        <div class="posBox" :class="{posBox1: btmBannerFlag === true}">
          <p class="txt1">{{ advertisingObj2.title }}</p>
          <p class="txt2">{{ advertisingObj2.desc }}</p>
          <p class="txt3">{{ advertisingObj2.extendContent }}</p>
        </div>
      </div>
    </div>
    <!-- 右边导航栏 -->
    <div class="shareBox">
      <div class="bx1" @click="toTop">
        <img
          class="img1"
          src="../../../static/images/icon09.png"
          style="width: 53px; height: 53px; margin: 3px 0 0 3px"
          alt=""
        />
        <span>回到顶部</span>
      </div>
      <div class="bx2">
        <img
          class="img1"
          src="../../../static/images/icon10.png"
          style="width: 53px; height: 53px; margin: 3px 0 0 3px"
          alt=""
        />
        <span>QQ客服</span>
      </div>
      <div class="bx3">
        <img
          class="img1"
          src="../../../static/images/icon11.png"
          style="width: 53px; height: 53px; margin: 3px 0 0 3px"
          alt=""
        />
        <span>{{ infoObj.phone }}</span>
      </div>
      <div class="bx4">
        <img
          class="img1"
          src="../../../static/images/icon12.png"
          style="width: 53px; height: 53px; margin: 3px 0 0 3px"
          alt=""
        />
        <span>微信二维码</span>
        <img class="img2" :src="infoObj.wxqrCode" alt="" />
      </div>
    </div>
    <defaulfooter />
    <!-- 移动端回到顶部 -->
    <div class="yidongTop" @click="toTop">
      <i class="el-icon-arrow-up"></i>
    </div>
  </div>
</template>

<script>
import {indexList, advertisingSlideshow, articleList, advertisingDetail, menuList, infoList} from '@/api/index'
import mobileHeader from '../../components/mobileheader.vue'
import '@/assets/css/index1.scss'
import defaulfooter from '@/components/defaulfooter'
import Swiper from 'swiper'
let timer = null //定义初始值
export default {
  name: 'home',
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      flag: false, //控制初始显示动画
      status: 1,
      show: false,
      jjflag: false, //控制简介动画
      productFlag: false, //控制产品动画
      imgFlag1: false,
      imgFlag2: false,
      leftFlag: false,
      rightFlag: false,
      ctnBoxFlag: false,
      btmBannerFlag: false,
      lunboNum: 1,
      swiperNum1: 0,
      swiperNum2: 0,
      swiperNum3: 0,
      // 数据
      homeList: [], //首页数据
      slideshowList: [], //轮播图列表
      articleList1: [], //文章列表1
      articleList2: [], //文章列表2
      articleList3: [], //文章列表3
      articleList4: [], //文章列表4
      menuList: [], //菜单列表
      advertisingObj1: {}, //广告位1
      advertisingObj2: {}, //广告位2
      infoObj: {} //公司基本信息
    }
  },
  created() {
    this.init()
    //在动态加载完数据后渲染swiper
    setTimeout(() => {
      this.swiper()
    }, 1000)
    // console.log('这是路由', this.$route)
    let vm = this
    window.onscroll = function () {
      if (document.documentElement.scrollTop > 60) {
        vm.isActive = true
      } else {
        vm.isActive = false
      }
    }
  },
  components: {
    defaulfooter,
    mobileHeader
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
    this.flag = true
    this.$nextTick(() => {
      setInterval(this.CurentTime, 3000)
    })
  },
  methods: {
    // 初始化数据
    init() {
      // 首页数据
      indexList({deptId: 112}).then(res => {
        // console.log('首页数据', res)
        this.homeList = res
        // 文章列表1
        let query = {
          deptId: 112,
          menuIds: res[2].menuIds,
          pageNum: 1,
          pageSize: res[2].articleShowNum
        }
        articleList(query).then(res => {
          // console.log('文章列表1数据', res)
          this.articleList1 = res.list
        })

        // 文章列表2
        let query1 = {
          deptId: 112,
          menuIds: res[3].menuIds,
          pageNum: 1,
          pageSize: res[3].articleShowNum
        }
        articleList(query1).then(res => {
          // console.log('文章列表2数据', res)
          this.articleList2 = res.list
        })

        //广告位
        advertisingDetail({advertisingId: res[4].advertisingId}).then(res => {
          // console.log('广告位数据', res)
          this.advertisingObj1 = res
        })

        //广告位1
        advertisingDetail({advertisingId: res[7].advertisingId}).then(res => {
          // console.log('广告位1数据', res)
          this.advertisingObj2 = res
        })

        // 文章列表3
        let query2 = {
          deptId: 112,
          menuIds: res[5].menuIds,
          pageNum: 1,
          pageSize: res[5].articleShowNum
        }
        articleList(query2).then(res => {
          // console.log('文章3数据', res)
          this.articleList3 = res
        })

        // 文章列表4
        let query3 = {
          deptId: 112,
          menuIds: res[6].menuIds,
          pageNum: 1,
          pageSize: res[6].articleShowNum
        }
        articleList(query3).then(res => {
          // console.log('文章4数据', res)
          this.articleList4 = res
        })

        // 合作商列表（文章）
        // let query4 = {
        //   deptId: 112,
        //   menuIds: res[8].menuIds,
        //   pageNum: 1,
        //   pageSize: res[8].articleShowNum
        // }
        // articleList(query4).then(res => {
        //   console.log('合作商列表数据', res)
        // })

        //菜单列表
        menuList({deptId: 112}).then(res => {
          console.log('菜单列表', res)
          this.menuList = res
        })
      })
      // 轮播图
      advertisingSlideshow({deptId: 112}).then(res => {
        // console.log('轮播图数据', res)
        this.slideshowList = res
      })
      //公司基本信息数据
      infoList({deptId: 112}).then(res => {
        // console.log('公司基本信息', res)
        this.infoObj = res
        document.title = res.companyName + '-' + res.websiteDesc
      })
    },
    toTop() {
      // 动画

      timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    },
    huidaodingbu() {
      // console.log('您点击了回到顶部', document.documentElement.scrollTop)
      document.documentElement.scrollTop = 0
    },
    CurentTime() {
      if (this.lunboNum === 1) {
        this.lunboNum = 2
      } else {
        this.lunboNum = 1
      }
    },
    swiper() {
      let that = this
      var mySwiper = new Swiper('.swiper-container', {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        effect: 'fade', //淡入淡出效果
        // loop: true,
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        autoplay: true,
        speed: 1000,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true //设置分页小圆点可手动点击
        }
      })
      new Swiper('.swiper-container1', {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        effect: 'fade', //淡入淡出效果
        loop: true,
        autoplay: true,
        speed: 1000,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true //设置分页小圆点可手动点击
        }
      })
      var mySwiper1 = new Swiper('.swiper-container2', {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        effect: 'fade', //淡入淡出效果
        // loop: true,
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        autoplay: true,
        speed: 1000,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true //设置分页小圆点可手动点击
        }
      })
      //头部banner轮播图
      var mySwiper2 = new Swiper('.swiper-container3', {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        effect: 'fade', //翻转方式/
        loop: true,
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        autoplay: true,
        speed: 1000,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true //设置分页小圆点可手动点击
        }
      })

      // console.log('您的轮播', mySwiper, mySwiper1)
      mySwiper[0].el.onmouseover = function () {
        //鼠标放上暂停轮播
        mySwiper[0].autoplay.stop()
      }
      mySwiper[0].el.onmouseleave = function () {
        mySwiper[0].autoplay.start()
      }
      mySwiper[1].el.onmouseover = function () {
        //鼠标放上暂停轮播
        mySwiper[1].autoplay.stop()
      }
      mySwiper[1].el.onmouseleave = function () {
        mySwiper[1].autoplay.start()
      }

      mySwiper1.el.onmouseover = function () {
        //鼠标放上暂停轮播
        mySwiper1.autoplay.stop()
      }
      mySwiper1.el.onmouseleave = function () {
        mySwiper1.autoplay.start()
      }

      mySwiper2.el.onmouseover = function () {
        //鼠标放上暂停轮播
        mySwiper2.autoplay.stop()
      }
      mySwiper2.el.onmouseleave = function () {
        mySwiper2.autoplay.start()
      }

      //主要是这部分
      mySwiper[0].on('slideChangeTransitionEnd', function () {
        that.swiperNum1 = mySwiper[0].activeIndex
        // console.log('内容：', that.swiperNum1)
      })
      mySwiper[1].on('slideChangeTransitionEnd', function () {
        that.swiperNum2 = mySwiper[1].activeIndex
        // console.log('内容：', that.swiperNum2)
      })
      mySwiper1.on('slideChangeTransitionEnd', function () {
        that.swiperNum3 = mySwiper1.activeIndex
        // console.log('内容：', that.swiperNum3)
      })
    },
    toProductDetails(id, num, bul) {
      this.$router.push({
        path: '/productDetails',
        query: {
          id: id,
          indexFlag: num,
          flag: bul
        }
      })
    },
    addLogo() {
      // console.log('你点击了LOGO,刷新当前页')
      location.reload()
    },
    //点击灯具跳转产品详情
    toProduct(val) {
      // console.log('这个是数字', this.menuList[0].id, this.menuList[0].childrenList[val].id)
      this.$router.push({
        path: '/product?id=' + this.menuList[0].id,
        query: {
          sortId: this.menuList[0].childrenList[val].id,
          index: val
        }
      })
    },
    //点击导航栏
    toPage(num) {
      if (num === 0) {
        this.$router.push({
          path: '/product?id=' + this.menuList[0].id
        })
      } else if (num === 1) {
        this.$router.push({
          path: '/aboutUs?id=' + this.menuList[1].id
        })
      } else if (num === 2) {
        this.$router.push({
          path: '/news?id=' + this.menuList[2].id
        })
      } else if (num === 3) {
        this.$router.push({
          path: '/contactUs?id=' + this.menuList[3].id
        })
      }
    },
    // 获取滚动条当前的位置
    getScrollTop() {
      var scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      // console.log('这是滚动距离', scrollTop)
      return scrollTop
    },
    // 滚动事件触发下拉加载
    onScroll() {
      if (this.getScrollTop() >= 100) {
        this.jjflag = true
      }
      if (this.getScrollTop() >= 400) {
        this.productFlag = true
      }
      if (this.getScrollTop() >= 720) {
        this.imgFlag1 = true
      }
      if (this.getScrollTop() >= 800) {
        this.rightFlag = true
      }
      if (this.getScrollTop() >= 1300) {
        this.imgFlag2 = true
      }
      if (this.getScrollTop() >= 1600) {
        this.leftFlag = true
      }
      if (this.getScrollTop() >= 2100) {
        this.ctnBoxFlag = true
      }
      if (this.getScrollTop() >= 2900) {
        this.btmBannerFlag = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../node_modules/swiper/css/swiper.min.css';
/deep/.swiper-pagination-bullet {
  border-radius: 0 !important;
}
/deep/.swiper-pagination-bullet-active {
  background: #000 !important;
}
.lunboSwiper {
  /deep/.swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    border-radius: 50% !important;
  }
  /deep/.swiper-pagination-bullet-active {
    background: #fff !important;
  }
}
</style>
